import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'seek-goals',
  templateUrl: './goals.component.html',
  styleUrls: ['./goals.component.scss']
})
export class GoalsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
